import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axiosClient from '../api/axiosClient';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import InputText from '../components/Input/InputText';
import Button from '../components/Button/Button';
import Typography from '../components/Typography';
import { theme } from '../theme';
import GoogleColorIcon from '../components/Icons/GoogleColorIcon';
import FacebookColorIcon from '../components/Icons/FacebookColorIcon';
import ChevronRightIcon from '../components/Icons/ChevronRightIcon';
import BackIcon from '../components/Icons/BackIcon';


const Signin = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation('signin');

  const location = useLocation();
  const returnTo = location.state?.returnTo || '/discover'; // Valor por defecto si no viene definido

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      // const response = await axiosClient.post('/api/users/check-or-register', { email });
      const response = await axiosClient.post('/api/users/check-or-register', { email, returnTo });

      if (response.data.success) {
        // Pasamos email y returnTo para que luego se pueda redirigir al usuario a la URL original
        navigate('/email-verification', { state: { email, returnTo } });
      } else {
        setError(response.data.message || 'Error enviando el email, por favor intenta de nuevo.');
      }
    } catch (err) {
      console.error('Error en Signin:', err);
      setError(err.response?.data?.message || 'Error procesando la solicitud, por favor intenta de nuevo.');
    }
  };

  const handleGoogleSignin = () => {
    const url = `${process.env.REACT_APP_API_URL}/auth/google?returnTo=${encodeURIComponent(returnTo)}`;
    window.location.href = url;
  };

  const handleFacebookSignin = () => {
    const url = `${process.env.REACT_APP_API_URL}/auth/facebook?returnTo=${encodeURIComponent(returnTo)}`;
    window.location.href = url;
  };

  return (
    <SigninContainer>
      <SigninBlock>
        <Header>
          <BackLink to={returnTo}>
            <BackIcon fill={theme.colors.defaultMain} height={16} width={16} />
          </BackLink>
          {/* <p>Únete o entra a Motorik</p> */}
          <Typography $variant="body-1-semibold">{t('signinHeader')}</Typography>
        </Header>

        <OauthSignin>
          <OauthHeading>
            <Typography $variant="title-5-semibold" as="h2">{t('oauthTitle')}</Typography>
            <Typography $variant="body-1-medium" as="p" color={theme.colors.defaultWeak}>{t('oauthSubtitle')}</Typography>
          </OauthHeading>
          <OauthButtons>
            <Button size="xl" $variant="outline" onClick={handleGoogleSignin}>
              <ProviderLabel>
                <GoogleColorIcon />
                {t('googleSigninButton')}
                {/* <Typography $variant="body-1-semibold" as="p" color={theme.colors.defaultMain}>{t('googleSigninButton')}</Typography> */}
              </ProviderLabel>
              <ChevronRightIcon fill={theme.colors.defaultMain} />
            </Button>
            {/* <Button className='FacebookSignin' onClick={handleFacebookSignin} $variant="outline" size="medium"><img src="icons/facebook-color.svg" alt="Google logo" /><p>{t('facebookSigninButton')}</p><img src="icons/chevron-right.svg" alt="arrow icon" /></Button> */}
          </OauthButtons>
        </OauthSignin>
        <EmailSigninForm onSubmit={handleEmailSubmit}>
          <Typography $variant="body-1-medium" color={theme.colors.defaultStrong} as="h2">{t('emailSigninSubtitle')}</Typography>
          <InputText
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t('emailPlaceholder')}
            required
            $size='large'
          />
          {error && <p>{error}</p>}
          <Button type='submit' size="xl" $contentAlign="space-between">
            {t('emailSigninButton')}
            <ChevronRightIcon fill={theme.colors.inverseMain} />
          </Button>
        </EmailSigninForm>
      </SigninBlock>
    </SigninContainer>
  );
};

export default Signin;

const SigninContainer = styled.div`
  height: 100vh;
  width: 100vw;
  height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px ${({ theme }) => theme.sizing.sm};
  background: ${({ theme }) => theme.fill.inverseStrong};
`;

const SigninBlock = styled.div`
  background: ${({ theme }) => theme.fill.defaultMain};
  max-width: 480px;
  border-radius: ${({ theme }) => theme.radius.xs};
`;

const OauthSignin = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.sizing.sm};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.sm};
`;

const OauthHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.xxs};
`;

const OauthButtons = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.sizing.sm};
    // padding-top: 16px;
`;

const ProviderLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.sizing.xs};
  flex-grow: 1;
`;

const Header = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  padding: ${({ theme }) => theme.sizing.sm};
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.border.defaultSubtle};
  gap: ${({ theme }) => theme.sizing.sm};
`;

const BackLink = styled(Link)`
  width: 16px;
  height: 16px;
  display: flex;
  flex-direction: row;

`;


const EmailSigninForm = styled.form`
  width: 100%;
  padding: ${({ theme }) => theme.sizing.sm};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.sm};
  border-top: 1px solid ${({ theme }) => theme.border.defaultSubtle};
`;
